import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		logged: false,
		username: "",
		url: ""
	},
	mutations: {
		login(state, { username, img }){
			if(username != undefined && username != ""){
				state.username = username;
				state.img = img;
			}
		},
		logout(state){
			state.username = "";
			state.img = "";
		}
	},
	actions: {
		login({ commit, state }, { username, img }) {
			commit('login', {
				username,
				img
			});
		},
		logout({ commit, state }){
			commit('logout');
		}
	},
	getters: {
		username: state => {
			return state.username
		},
		img: state => {
			return state.img
		},
		logged: state => {
			return (state.username != undefined && state.username != "");
		}
	}
})
